/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { YearImages } from '../../models/year-images';

export interface GetYearImages$Params {
  year?: string;
}

export function getYearImages(http: HttpClient, rootUrl: string, params?: GetYearImages$Params, context?: HttpContext): Observable<StrictHttpResponse<YearImages>> {
  const rb = new RequestBuilder(rootUrl, getYearImages.PATH, 'get');
  if (params) {
    rb.query('year', params.year, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<YearImages>;
    })
  );
}

/**
 * Custom addition for our mocking infrastructure
 * in case this ever causes problems we can also keep a dictionary that maps operations to paths on the side
 **/
getYearImages.PATH = '/api/featuredetails/getyearimages';
getYearImages.METHOD = 'get';

/**
 * we annotate each endpoint with a root rootUrl
 * this is because we have multiple APIs so we need to know which api fn belongs to
 * so we can map it depending on the env. rootUrl is picked from the first server listed in the APISpec
 **/
getYearImages.ROOTURL = '/portal';
